import type { PartType } from '../../../types';

type PartLabelStrings = {
    PART_BATTERY: string;
    PART_ESC: string;
    PART_FLOW_METER: string;
    PART_MOTOR: string;
    PART_NOZZLE_SET: string;
    PART_PROP_SET: string;
    PART_PUMP_SEAL_KIT: string;
    PART_RTK_ANTENNA: string;
};

export const getPartLabels = (strings: PartLabelStrings): Record<PartType, string> => ({
    battery: strings.PART_BATTERY,
    esc: strings.PART_ESC,
    flowMeter: strings.PART_FLOW_METER,
    motor: strings.PART_MOTOR,
    nozzleSet: strings.PART_NOZZLE_SET,
    propSet: strings.PART_PROP_SET,
    pumpSealKit: strings.PART_PUMP_SEAL_KIT,
    rtkAntenna: strings.PART_RTK_ANTENNA
});
